import * as Yup from 'yup'
import { isValidPhoneNumber } from 'react-phone-number-input'

export const firstNameValidation = Yup.string()
  .matches(/^[A-Za-z ]+$/, 'First name can only contain letters')
  .trim()
  .min(2, 'First name must be at least 2 characters')
  .max(55, 'First name cannot exceed 55 characters')
  .required('First name is required')

export const lastNameValidation = Yup.string()
  .matches(/^[A-Za-z ]+$/, 'Last name can only contain letters')
  .trim()
  .min(2, 'Last name must be at least 2 characters')
  .max(55, 'Last name cannot exceed 55 characters')
  .required('Last name is required')

export const emailValidation = Yup.string()
  .trim()
  .email('Please enter a valid Email')
  .max(100, 'Email must not exceed 100 characters')
  .required('Email is required')

export const emailOptionalValidation = Yup.string()
  .trim()
  .email('Please enter a valid Email')
  .max(100, 'Email must not exceed 100 characters')

export const addressValidation = Yup.string()
  .trim()
  .min(2, 'Address must be at least 2 characters')
  .max(255, 'Address must be at most 255 characters')

export const phoneNumberValidation = Yup.string()
  .required('Phone number is required')
  .test('is-valid-phone', 'Invalid phone number', value => {
    return value ? isValidPhoneNumber(value) : false
  })

export const imeiNumberValidation = Yup.string()
  .trim()
  .matches(/^\d{15}$/, 'IMEI must be exactly 15 digits and only contains numbers')
  .min(15, 'IMEI must be exactly 15 digits and only contains numbers')
  .max(15, 'IMEI must be exactly 15 digits and only contains numbers')
  .required('IMEI Number is required')

export const modelNumberValidation = Yup.string().trim().required('Model Number is required')
